var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v(_vm._s(_vm.titulo))]),
    _c("h5", { staticStyle: { color: "#aaaaaa" } }, [
      _vm._v(_vm._s(_vm.subtitulo))
    ]),
    _vm.datos == null
      ? _c("div", { staticClass: "mt-3 mb-4" }, [
          _c("p", [
            _vm._v(
              " Este proceso podría tardar mas de lo esperado, ya que se consulta directamente en el servicio de impuestos internos. "
            )
          ]),
          _c("br"),
          _c("p", [_vm._v("¿Desea Continuar?")]),
          _c(
            "div",
            { staticClass: "mt-3", staticStyle: { "text-align": "right" } },
            [
              _c(
                "vs-button",
                {
                  staticStyle: { "margin-right": "15px" },
                  attrs: { type: "filled", color: "primary" },
                  on: { click: _vm.consultarSii }
                },
                [_vm._v("Consultar anotaciones")]
              )
            ],
            1
          )
        ])
      : _c("div", [
          _c(
            "div",
            { attrs: { slot: "header", align: "center" }, slot: "header" },
            [
              _c("h4", [
                _vm._v(
                  "Anotaciones SII Documento #" + _vm._s(_vm.getData.folio)
                )
              ])
            ]
          ),
          _vm.datos.referenciasTipoDte.length > 0
            ? _c(
                "div",
                { attrs: { align: "center" } },
                [
                  _c(
                    "vs-table",
                    {
                      attrs: { data: _vm.datos.referenciasTipoDte },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var datos = ref.datos
                              return _vm._l(datos, function(tr, indextr) {
                                return _c(
                                  "vs-tr",
                                  { key: indextr },
                                  [
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: { data: datos[indextr].estado }
                                      },
                                      [
                                        datos[indextr].estado == 1
                                          ? _c("div", [_vm._v(" Creado ")])
                                          : _vm._e(),
                                        datos[indextr].estado == 2
                                          ? _c("div", [
                                              _vm._v(" En Aprobación ")
                                            ])
                                          : _vm._e(),
                                        datos[indextr].estado == 10
                                          ? _c("div", [_vm._v(" Aprobado ")])
                                          : _vm._e(),
                                        datos[indextr].estado == 9
                                          ? _c("div", [_vm._v(" Rechazado ")])
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: { data: datos[indextr].numero }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(datos[indextr].numero) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: {
                                          data: datos[indextr].nombreDescriptivo
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              datos[indextr].nombreDescriptivo
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: {
                                          data: datos[indextr].fechaEmision
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              datos[indextr].fechaEmision
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            }
                          }
                        ],
                        null,
                        false,
                        2389611396
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "thead" },
                        [
                          _c("vs-th", [_vm._v("Estado")]),
                          _c("vs-th", [_vm._v("Número")]),
                          _c("vs-th", [_vm._v("Nombre")]),
                          _c("vs-th", [_vm._v("Fecha Emisión")])
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _c("div", [
                _c("span", { attrs: { align: "center" } }, [
                  _vm._v("No existen registros asociados")
                ])
              ])
        ]),
    _vm.error
      ? _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "vs-alert",
              {
                staticClass: "mensaje",
                attrs: { title: "Alerta", active: _vm.error, color: "danger" }
              },
              [
                _vm._v(
                  " Error al realizar la operación, reinténtelo más tarde o contacte a soporte Narvi. "
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }